import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MapState } from './map.reducer';

export const selectMapState = createFeatureSelector<MapState>('map');

export const mapSelector = createSelector(
  selectMapState,
  (state: MapState) => state.map
);

export const sectorsSelector = createSelector(
  selectMapState,
  (state: MapState) => state.sectors
);

export const selectedSectorSelector = createSelector(
  selectMapState,
  (state: MapState) => state.selectedSector
);

export const showSelector = createSelector(
  selectMapState,
  (state: MapState) => state.isShowing
);

export const viewSelector = createSelector(
  selectMapState,
  (state: MapState) => state.view
);

export const loadingSelector = createSelector(
  selectMapState,
  (state: MapState) => state.isLoading
);